import React, { useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../config';

const LOG_ENABLED = process.env.REACT_APP_ENABLE_LOG === 'true';

const EnviarComunicado = ({ onVolver }) => {
  const [canal, setCanal] = useState('email'); // email o sms
  const [segmento, setSegmento] = useState('todos'); // todos, militar, civil, depto, cumple
  const [departamento, setDepartamento] = useState('');
  const [asunto, setAsunto] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [status, setStatus] = useState('idle');
  const [responseMessage, setResponseMessage] = useState('');

  const handleSend = async (e) => {
    e.preventDefault();
    if (canal === 'email' && !asunto) {
      alert('El asunto es obligatorio para correos.');
      return;
    }
    if (!mensaje) {
      alert('El mensaje no puede estar vacío.');
      return;
    }

    setStatus('sending');
    
    const payload = {
      canal,
      segmento,
      departamento: segmento === 'depto' ? departamento : null,
      asunto: canal === 'email' ? asunto : null,
      mensaje,
      automatico_cumple: segmento === 'cumple'
    };

    if (LOG_ENABLED) console.log('📤 Enviando comunicado segmentado:', payload);

    try {
      if (!BACKEND_URL) {
        throw new Error('BACKEND_URL no configurado.');
      }
      const cleanUrl = BACKEND_URL.trim().replace(/\/$/, '');
      const res = await axios.post(`${cleanUrl}/api/comunicados/enviar`, payload);
      const total = res.data?.total ?? 0;
      const encolados = res.data?.encolados ?? 0;
      setStatus('success');
      setResponseMessage(`Comunicado encolado. Destinatarios: ${encolados}/${total}.`);
    } catch (err) {
      setStatus('error');
      setResponseMessage(err.response?.data?.error || err.message || 'Error al procesar el envío masivo.');
    }
  };

  return (
    <div className="bg-light min-vh-100 pb-5">
      <div 
        className="bg-white border-bottom d-flex align-items-center sticky-top shadow-sm px-3 py-3"
        onClick={onVolver}
        style={{cursor: 'pointer'}}
      >
        <i className="bi bi-arrow-left fs-3 me-3 text-primary"></i>
        <h5 className="mb-0 fw-bold">Enviar Comunicado</h5>
      </div>

      <div className="container mt-4 px-3" style={{maxWidth: '700px'}}>
        {status === 'success' && <div className="alert alert-success shadow-sm border-0">{responseMessage}</div>}
        
        <form onSubmit={handleSend} className="card border-0 shadow-sm p-4" style={{borderRadius: '15px'}}>
          
          {/* Selección de Canal */}
          <label className="form-label text-muted small fw-bold mb-3">¿POR QUÉ MEDIO ENVIAR?</label>
          <div className="d-flex gap-3 mb-4">
            <div 
              className={`flex-fill p-3 border rounded-3 text-center pointer ${canal === 'email' ? 'border-primary bg-primary bg-opacity-10' : 'bg-white'}`}
              onClick={() => setCanal('email')}
              style={{cursor:'pointer'}}
            >
              <i className={`bi bi-envelope-at fs-3 ${canal === 'email' ? 'text-primary' : 'text-muted'}`}></i>
              <div className={canal === 'email' ? 'fw-bold text-primary' : 'text-muted'}>Correo</div>
            </div>
            <div 
              className={`flex-fill p-3 border rounded-3 text-center pointer ${canal === 'sms' ? 'border-primary bg-primary bg-opacity-10' : 'bg-white'}`}
              onClick={() => setCanal('sms')}
              style={{cursor:'pointer'}}
            >
              <i className={`bi bi-chat-left-text fs-3 ${canal === 'sms' ? 'text-primary' : 'text-muted'}`}></i>
              <div className={canal === 'sms' ? 'fw-bold text-primary' : 'text-muted'}>SMS</div>
            </div>
          </div>

          {/* Segmentación */}
          <div className="mb-4">
            <label className="form-label text-muted small fw-bold uppercase">Destinatarios (Filtros)</label>
            <select className="form-select mb-2" value={segmento} onChange={(e) => setSegmento(e.target.value)}>
              <option value="todos">Todos los registrados</option>
              <option value="militar">Solo Personal Militar</option>
              <option value="civil">Solo Personal Civil</option>
              <option value="depto">Por Departamento Específico</option>
              <option value="cumple">🎂 Cumpleañeros del Mes (Automático)</option>
            </select>

            {segmento === 'depto' && (
              <input 
                type="text" 
                className="form-control mt-2 fade-in" 
                placeholder="Nombre del departamento (Ej: RRHH)" 
                value={departamento}
                onChange={(e) => setDepartamento(e.target.value)}
                required
              />
            )}
          </div>

          {/* Contenido */}
          <div className="mb-4">
            <label className="form-label text-muted small fw-bold">Mensaje</label>
            {canal === 'email' && (
              <input 
                type="text" 
                className="form-control mb-2" 
                placeholder="Asunto del correo" 
                value={asunto}
                onChange={(e) => setAsunto(e.target.value)}
                required
              />
            )}
            <textarea 
              className="form-control" 
              rows="6" 
              placeholder={canal === 'sms' ? "Mensaje corto (máx 160 caracteres)" : "Escriba el cuerpo del comunicado aquí..."}
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
              required
            ></textarea>
            <div className="form-text small text-muted">Puedes usar tag <code>{"{nombre}"}</code> para personalizar el saludo.</div>
          </div>

          <button type="submit" className="btn btn-primary w-100 py-3 fw-bold shadow" disabled={status === 'sending'}>
            {status === 'sending' ? 'PROCESANDO ENVÍO...' : `ENVIAR POR ${canal.toUpperCase()}`}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnviarComunicado;
